'use client';

import { useRouter } from '@bprogress/next/app';
import { useEffect } from 'react';

import { useDocumentVisibility } from './useDocumentVisibility';

export function DocumentVisibilityRefresh() {
  const { isDocumentVisible, isMounted } = useDocumentVisibility();
  const router = useRouter();

  useEffect(() => {
    const t = setTimeout(() => {
      if (isMounted && isDocumentVisible) {
        router.refresh();
      }
    }, 1000);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDocumentVisible]);

  return null;
}
